// extracted by mini-css-extract-plugin
export var box = "_1x-1";
export var checked = "_1x-2";
export var descriptionSpacer = "_1x-9";
export var disabled = "_1x-3";
export var icon = "_1x-6";
export var input = "_1x-0";
export var labelSpacer = "_1x-8";
export var medium = "_1x-5";
export var small = "_1x-4";
export var text = "_1x-7";